import React, { useEffect } from 'react';
import { Form, Input, InputNumber, Modal, Upload, Button, Switch, message, Row, Col } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const BrandsForm = ({ visible, onCreate, onCancel, record }) => {
  const [form] = Form.useForm();

  // Populate form when editing, reset when adding
  useEffect(() => {
    if (visible) {
      if (record) {
        form.setFieldsValue({
          _id: record.id,
          name: record.name,
          printname: record.printname,
          ordinal: record.ordinal,
          isForAll: record.isForAll ?? false,
        });
      } else {
        form.resetFields();
      }
    }
  }, [visible, record, form]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        onCreate(values);
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      open={visible}
      title={record ? 'Update Brand' : 'Add Brand'}
      okText="Submit"
      cancelText="Cancel"
      onCancel={handleCancel}
      onOk={handleOk}
      width={800}
      zIndex={99999}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        name="brand_form"
        initialValues={{ isForAll: false }}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="name"
              label="Name"
              rules={[{ required: true, message: 'Name is required' }]}
            >
              <Input placeholder="Enter brand name" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item name="printname" label="Print Name">
              <Input placeholder="Enter print name (optional)" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="ordinal"
              label="Ordinal"
              rules={[{ type: 'number', message: 'Ordinal should be a number' }]}
            >
              <InputNumber placeholder="Enter ordinal (optional)" style={{ width: '100%' }} />
            </Form.Item>
          </Col>
        </Row>

        {/* isForAll — only shown when adding, not editing */}
        {!record && (
          <Row>
            <Col span={24}>
              <Form.Item name="isForAll" label="Add For All" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
          </Row>
        )}
      </Form>
    </Modal>
  );
};

export default BrandsForm;